import { IClient } from "intake_shared/src/types";

const getClientsWithBooking = (clients: IClient[]) =>
    clients.filter((client: IClient) => client.confirmed_bookings.length > 0);

export { getClientsWithBooking };
